import { Box, Grid, SimpleGrid } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { MonthPicker, Select, TextInput, YesNoRadioButton } from "components";
import { TFunction } from "i18next";

interface CardEmploymentProps {
  form: UseFormReturnType<any, any>;
  t: TFunction;
}

const CardEmployment = ({ form, t }: CardEmploymentProps) => {

  return (
    <Box p={'lg'}>
      <SimpleGrid cols={4}>
        <Select
          label={t('user.professionalSituation.label')}
          placeholder={t('select.something')}
          key={form.key('professionalSituation')}
          {...form.getInputProps('professionalSituation')}
          data={form.getInputProps('professionalSituation').defaultValue && [{
            value: form.getInputProps('professionalSituation').defaultValue,
            label: t(`user.professionalSituation.options.${form.getInputProps('professionalSituation').defaultValue}`),
          }]}
          disabled={true}
        />
        <TextInput
          label={t('user.monthlyNetIncome.label')}
          key={form.key('monthlyNetIncome')}
          {...form.getInputProps('monthlyNetIncome')}
          value={form.getInputProps('monthlyNetIncome').value}
          disabled={true}
        />
        <YesNoRadioButton
          label={t('user.thirteenthSalary.label')}
          name={'thirteenthSalary'}
          form={form}
          disabled={true}
        />
        <TextInput
          label={t('user.monthlyNetIncomePartner.label')}
          key={form.key('monthlyNetIncomePartner')}
          {...form.getInputProps('monthlyNetIncomePartner')}
          value={form.getInputProps('monthlyNetIncomePartner').value}
          disabled={true}
        />
      </SimpleGrid>
      <SimpleGrid cols={4}>
        <YesNoRadioButton
          label={t('user.thirteenthSalaryPartner.label')}
          name={'thirteenthSalaryPartner'}
          form={form}
          disabled={true}
        />
        <TextInput
          label={t('user.monthlyRentExpenses.label')}
          key={form.key('monthlyRentExpenses')}
          {...form.getInputProps('monthlyRentExpenses')}
          value={form.getInputProps('monthlyRentExpenses').value}
          disabled={true}
        />
        <TextInput
          label={t('user.monthlyAlimonyExpenses.label')}
          key={form.key('monthlyAlimonyExpenses')}
          {...form.getInputProps('monthlyAlimonyExpenses')}
          value={form.getInputProps('monthlyAlimonyExpenses').value}
          disabled={true}
        />
      </SimpleGrid>
      <SimpleGrid cols={4} mt={'md'}>
        <TextInput
          label={t('user.companyName.label')}
          key={form.key('companyName')}
          {...form.getInputProps('companyName')}
          value={form.getInputProps('companyName').value}
          disabled={true}
        />
        <TextInput
          label={t('user.companyCountry.label')}
          key={form.key('companyCountry')}
          {...form.getInputProps('companyCountry')}
          value={form.getInputProps('companyCountry').defaultValue && t('user.address.country.options.' + form.getInputProps('companyCountry').defaultValue)}
          disabled={true}
        />
        <Grid>
          <Grid.Col span={4}>
            <TextInput
              label={t('user.companyPostal.label')}
              key={form.key('companyPostal')}
              {...form.getInputProps('companyPostal')}
              disabled={true}
            />
          </Grid.Col>
          <Grid.Col span={8}>
            <TextInput
              label={t('user.companyCity.label')}
              key={form.key('companyCity')}
              {...form.getInputProps('companyCity')}
              disabled={true}
            />
          </Grid.Col>
        </Grid>
        <Box>
          <MonthPicker
            label={t('user.companyEmployedAt.label')}
            placeholder={t('user.birthDate.placeholder')}
            key={form.key('companyEmployedAt')}
            {...form.getInputProps('companyEmployedAt')}
            disabled={true}
          />
        </Box>
      </SimpleGrid>
    </Box>
  )
}

export default CardEmployment;